// Fix bugs, ionic detect iPad Pro not correct
//https://stackoverflow.com/questions/56578799/tell-ipados-from-macos-on-the-web
ionic.Platform.isIPad = function () {
    let isMobile = (/ipad/).test(navigator.userAgent.toLowerCase());
    let ios13 = (navigator.userAgent.toLowerCase().includes("macintosh") && "ontouchend" in document);
    //console.log('isIPad', isMobile, ios13)
    return isMobile || ios13;
}
ionic.Platform.isIOS = function () {
    let isMobile = (/iphone|ipad|ipod/).test(navigator.userAgent.toLowerCase());
    let ios13 = (navigator.userAgent.toLowerCase().includes("macintosh") && "ontouchend" in document);
    //console.log('isIOS', isMobile, ios13)
    return isMobile || ios13;
}
if (ionic.Platform.isIOS()) {
    ionic.Platform.setPlatform('ios');
}
